import { BlocksTabs } from 'blocks-nextjs/blocks-web-components/components/tabs/tabs';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatTabs = createComponent({
    react: React,
    tagName: 'cat-tabs',
    elementClass: BlocksTabs,
    events: {
        onBlTabChange: 'bl-tab-change'
    }
});
